"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var AccordionSummary_1 = __importDefault(require("atomicComponents/atoms/Accordion/AccordionSummary"));
var Accordion2_1 = __importDefault(require("shared/components/Accordion2"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion2/AccordionDetails"));
var utils_1 = require("../../utils");
var RecommendationLine_1 = __importDefault(require("../components/RecommendationLine"));
var RecommendationLineHeader_1 = __importDefault(require("../components/RecommendationLineHeader"));
var SavingsListRow_1 = __importDefault(require("./SavingsListRow"));
var StatAccordion = function (_a) {
    var _b;
    var serviceStat = _a.serviceStat, showBreakdown = _a.showBreakdown, maxSpend = _a.maxSpend;
    var _c = __read(react_1.default.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    return ((0, jsx_runtime_1.jsxs)(Accordion2_1.default, __assign({ onChange: function (e, open) { return setIsOpen(open); } }, { children: [(0, jsx_runtime_1.jsx)(AccordionSummary_1.default, __assign({ iconSize: "sm", sx: { py: 0, mb: 0.5 } }, { children: (0, jsx_runtime_1.jsx)(SavingsListRow_1.default, { item: serviceStat, maxSpend: maxSpend, isOpen: isOpen }) })), (0, jsx_runtime_1.jsxs)(AccordionDetails_1.default, { children: [(0, jsx_runtime_1.jsx)(RecommendationLineHeader_1.default, {}), showBreakdown && ((_b = serviceStat.toolAnalysis.recommendations) === null || _b === void 0 ? void 0 : _b.map(function (reco) { return ((0, jsx_runtime_1.jsx)(RecommendationLine_1.default, { recommendation: reco, amount: (0, utils_1.getForecast)(serviceStat) }, reco.type)); })), (0, jsx_runtime_1.jsx)(RecommendationLine_1.default, { isEmpty: true })] })] })));
};
exports.default = StatAccordion;
